import * as React from 'react';
import { DataLayer, WebPage } from '@grandvisionhq/analytics';
import { TryInStoreProvider } from '@grandvisionhq/fun-try-in-store';
import { monetate } from '@grandvisionhq/svc-monetate';
import '@swc/helpers';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@grandvisionhq/state';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/utils';
import { getPageSeo } from '../utils/get-page-seo.js';
import '@grandvisionhq/common';
import '../utils/http-client.js';
import { mapMonetatePageType } from '../utils/map-monetate-page-type.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../operations/mutations/signup-promotion.js';
import '../operations/mutations/subscribe-newsletter.js';
import '../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachPageName } from '../hooks/use-bloomreach-page-name.js';
import '../hooks/use-breakpoint-visibility.js';

const CmsAnalytics = ()=>{
    const page = useBrPageContext();
    const pageSeo = getPageSeo(page);
    const casedPageName = useBloomreachPageName();
    const pageName = casedPageName === null || casedPageName === void 0 ? void 0 : casedPageName.toLowerCase();
    React.useEffect(()=>{
        const seoPageType = pageSeo === null || pageSeo === void 0 ? void 0 : pageSeo.type;
        DataLayer.pushPageTypeToDataLayer(seoPageType, pageName);
        if (seoPageType && !(pageName === null || pageName === void 0 ? void 0 : pageName.includes('checkout')) && !(pageName === null || pageName === void 0 ? void 0 : pageName.includes('product-detail-page'))) {
            const monetatePageName = mapMonetatePageType(seoPageType);
            // Some opcos don't have the pageseo correctly setup for homepage
            if (pageName === 'homepage') {
                monetate().commitMonetateEvent('main');
            } else if (// These pages contain other monetate API calls which need to be called simultaneously, so the pages will commit the event themselves
            monetatePageName !== 'category' && monetatePageName !== 'product' && monetatePageName !== 'cart') {
                monetate().commitMonetateEvent(monetatePageName);
            }
        }
    }, []);
    return pageSeo ? /*#__PURE__*/ React.createElement(WebPage, {
        pageType: pageSeo.type,
        url: pageSeo.canonicalUrl,
        name: pageSeo.title,
        description: pageSeo.description
    }) : null;
};
const CmsContainerPage = ({ children  })=>{
    return /*#__PURE__*/ React.createElement(TryInStoreProvider, null, children, /*#__PURE__*/ React.createElement(CmsAnalytics, null));
};

export { CmsContainerPage, CmsContainerPage as default };
//# sourceMappingURL=container.js.map
